import React from 'react';
import { connect } from 'react-redux';
import { Outlet } from 'react-router-dom';

import Application from '@common/react/components/Core/Application/Application';
import ServerPageProvider from '@common/react/components/Core/ServerPageProvider/ServerPageProvider';
import { RequestProvider } from '@common/react/components/RequestProvider/RequestProvider';

import ErrorBoundary from '@app/components/UI/ErrorBoundary/ErrorBoundary';
import ErrorPageContent from '@app/components/UI/ErrorPageContent/ErrorPageContent';
import { ApplicationState } from '@app/store';

const LayoutWrapper = () => {
	return (
		<ErrorBoundary>
			<RequestProvider
				errorComponents={{
					errorPage: ErrorPageContent,
					accessDenied: ErrorPageContent,
				}}
			>
				<Application>
					<ServerPageProvider
						getIgnoreServerPage={() => true}
						notFoundComponent={<ErrorPageContent />}
						inner={() => <Outlet />}
					/>
				</Application>
			</RequestProvider>
		</ErrorBoundary>
	);
};

export default connect<any, any, any, ApplicationState>((state: ApplicationState) => state.login)(LayoutWrapper);
